"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetCategory = exports.getMissingMatches = exports.searchMatches = void 0;
var core_1 = __importDefault(require("@gin-betting/core"));
var constants_1 = require("./constants");
var _a = core_1.default.entities.actions, makeSearchMatchesFn = _a.makeSearchMatchesFn, makeGetMissingMatches = _a.makeGetMissingMatches, makeAction = core_1.default.utils.makeAction;
exports.searchMatches = makeSearchMatchesFn(constants_1.GET_MATCHES_REQUEST);
exports.getMissingMatches = makeGetMissingMatches({
    type: constants_1.GET_MISSING_MATCHES_REQUEST,
    withMarketsCount: true,
});
var resetCategory = function (payload) {
    return makeAction(constants_1.RESET_MATCHES_CATEGORY, payload);
};
exports.resetCategory = resetCategory;
//# sourceMappingURL=actions.js.map